import { Directive, OnDestroy } from '@angular/core';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';

@Directive({
  selector: '[appAutocompletePosition]',
  exportAs: 'appAutocompletePosition',
  standalone: true,
})
export class AutocompletePositionDirective implements OnDestroy {
  public constructor(private readonly matAutocompleteTrigger: MatAutocompleteTrigger) {
    window.addEventListener('scroll', this.scrollEvent, true);
  }

  public ngOnDestroy(): void {
    window.removeEventListener('scroll', this.scrollEvent, true);
  }

  private scrollEvent = (event: Event): void => {
    if (this.matAutocompleteTrigger == null) {
      return;
    }

    const target = event.target as HTMLElement;
    const panel = this.matAutocompleteTrigger.autocomplete.panel.nativeElement;

    if (!panel.contains(target) && this.matAutocompleteTrigger.panelOpen) {
      this.matAutocompleteTrigger.closePanel();
    }
  };
}
